import React, { useEffect, useState } from 'react'

import { ThemeSwitcher, ButtonRed, ButtonPink, ButtonGrey } from '../../components/common/Button'
import { InterestButton } from '../../components/auth'
import { useHistory } from 'react-router-dom'

import { createUser } from '../../api/auth'
import { useDispatch } from 'react-redux'

export default function VIntermediate() {
    const history = useHistory();
    const [LoadingData, setLoadingData] = useState(false);
    const dispatch = useDispatch();


    const [userData, setUserdata] = useState({
        email: "",
        password: "",
        displayName: "",
        userType: 1,
        username: "",
        gender: -1,
        tags: [],
    })

    const handleSelection = (e) => {
        console.log('setting useer info');
        setUserdata({ email: userData.email, password: userData.password, displayName: userData.displayName, userType: userData.userType, username: userData.username, gender: e, tags: [] })
        console.log('user info is:', userData);
    }

    const handleRegister = async () => {
        console.log("wew are in the handle register")
        try {
            setLoadingData(true);
            console.log(userData.email, userData.password, userData.displayName, userData.gender, userData.userType, userData.username, userData.tags)
            const res = await createUser(userData.email, userData.password, userData.displayName, userData.gender, userData.userType, userData.username, userData.tags)
            console.log('response is after registration: ', res);
            dispatch({
                type: 'TOOGLE_LOGGEDIN'
            })
            dispatch({
                type: 'UPDATE_USER_DATA',
                payload: res,
            })
            dispatch({
                type: 'UPDATE_NAV', payload: {
                    notification: false,
                    home: true,
                    search: false,
                    post: false,
                    chat: false,
                    profile: false
                }
            })
            document.getElementById('desktopWrapper').style.display = 'flex';
            document.getElementById('mobileWrapper').style.display = 'flex';
            document.getElementById('desktopNav').style.display = 'flex';
            history.push('/home')
        } catch (e) {
            // error handling and other msgs here
            setLoadingData(false);
        }
    }


    useEffect(() => {
        const historyData = history.location.state;
        if (historyData) {
            console.log('we have a history data and setting it now')
            setUserdata(historyData);
            console.log(userData)
        }
    }, [])

    return (
        <div className="lover-auth-intermediate">
            <ThemeSwitcher />
            <img className='lover-logo lover-logo-size' src={require('../../assets/icons/logo.svg')} />
            <h5 className="lover-auth-intermediate-header" >What interests you?</h5>
            <p className="lover-auth-intermediate-desc">We want your experience to be complete, so we need to know what kind of content is relevant for you.</p>

            <div className="lover-auth-intermediate-action-viewer">
                <InterestButton
                    mActiveIcon="male.svg"
                    mIcon="maleinactive.svg"
                    mText="Male"

                    fActiveIcon="female.svg"
                    fIcon="femaleinactive.svg"
                    fText="Female"

                    bActiveIcon="both.svg"
                    bIcon="bothinactive.svg"
                    bText="Both"

                    handleClick={handleSelection}
                />
                {userData.gender != -1 ? <ButtonRed icon="tick.svg" text={LoadingData ? "Please Wait" : "CONFIRM"} handleOnClick={handleRegister} /> : <ButtonGrey icon="tick.svg" text="CONFIRM" />}
                <ButtonPink text="BACK" navigateTo='/register' />
            </div>
        </div>
    )
}
